import { useState } from 'react';

export const useStepper = ({ stepsLength }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState({});
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [stepIconColor, setStepIconColor] = useState('defaultColor');
  const [step4Completed, setStep4Completed] = useState(false);

  const isLastStep = () => {
    return activeStep === stepsLength - 1;
  };

  const allStepsCompleted = () => {
    return Object.keys(completed).length === stepsLength;
  };

  const handleNext = () => {
    if (allStepsCompleted()) {
      // Restablece solo para los casos en los que se presiona siguiente después de completar todo
      handleReset();
    } else if (isLastStep()) {
      // Es el último paso, pero ya se maneja en handleFinish, esto es por si acaso
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
    // Aquí podrías cambiar el color del icono en cada paso si es necesario
    setStepIconColor('red');
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    setStepIconColor('defaultColor'); // O el color que corresponda
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
    setIsCheckboxChecked(false);
    setStepIconColor('defaultColor');
  };

  const handleComplete = () => {
    const newCompleted = { ...completed, [activeStep]: true };
    setCompleted(newCompleted);

    if (isLastStep()) {
      handleNext();
    }
  };

  const handleFinish = () => {
    const newCompleted = { ...completed };
    for (let step = activeStep; step < stepsLength; step++) {
      newCompleted[step] = true;
    }
    setCompleted(newCompleted);
    setActiveStep(stepsLength - 1);
    setStepIconColor('red');
    setStep4Completed(true)
  };

  return {
    activeStep,
    completed,
    isCheckboxChecked,
    setIsCheckboxChecked,
    handleNext,
    handleBack,
    handleComplete,
    handleReset,
    handleFinish,
    allStepsCompleted,
    stepIconColor,
    step4Completed,
  };
};
